import { render } from "./ChipInput.vue?vue&type=template&id=7b0fced2&scoped=true"
import script from "./ChipInput.vue?vue&type=script&lang=js"
export * from "./ChipInput.vue?vue&type=script&lang=js"

import "./ChipInput.vue?vue&type=style&index=0&id=7b0fced2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b0fced2"]])

export default __exports__